import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import getAvatarUrl from "../../../../utils/get-avatar-url";
import SvgIcon from "../../../../parts/SvgIcon";
import useClickOutside from "../../../../hooks/useClickOutside";
import useOverflow from "../../../../hooks/useOverflow";

const ChooseCoach = ({
  activeUser,
  organizationActiveUsers,
  onSelectCoach,
  selectedCoach,
  classNames = "",
}) => {
  const { t } = useTranslation("dashboard");
  const [isUnfolded, setIsUnfolded] = useState(false);
  const dropdownRef = useRef(null);
  useClickOutside(
    dropdownRef,
    () => {
      setIsUnfolded(false);
    },
    isUnfolded
  );
  // const [currentCoach, setCurrentCoach] = useState(coach);
  const [elementRef, overflowState, adjustHeight] = useOverflow();
  const activeUserId = activeUser._id;

  useEffect(() => {
    if (isUnfolded) {
      adjustHeight();
    }
  }, [isUnfolded, overflowState.bottom]);
  /**
   * Order the list by name (descending) and also the first option would be the active currentCoach
   * @param {*} a
   * @param {*} b
   * @returns
   */
  function sortElements(array) {
    // get current currentCoach objet
    const currentUser = array.find((item) => item._id === activeUserId);

    // sort the rest by descending name
    const others = array
      .filter((item) => item._id !== activeUserId)
      .sort((a, b) => b.name.localeCompare(a.name));

    // add the current currentCoach to the beginning of the array. The viewer is
    // not always in the list — a Team Coach is left out of the assignable ones,
    // since they never hold assigned clients — and pinning an absent one would
    // put an undefined entry in the dropdown.
    return currentUser ? [currentUser, ...others] : others;
  }
  return (
    <details
      ref={dropdownRef}
      role="list"
      open
      className={`dropdown-img ${classNames}`}
    >
      <summary
        onClick={(e) => {
          e.preventDefault();
          setIsUnfolded(!isUnfolded);
        }}
      >
        {selectedCoach ? (
          <>
            <img src={getAvatarUrl(selectedCoach)} alt={t("manageCoaches.coachAvatarAlt")} />
            <p>{selectedCoach.name}</p>
          </>
        ) : (
          <p>{t("manageCoaches.chooseCoach")}</p>
        )}
        <SvgIcon
          src={isUnfolded ? "/img/svg/angle-up.svg" : "/img/svg/angle-down.svg"}
        />
      </summary>
      <ul className={isUnfolded ? "opened" : ""} ref={elementRef}>
        {sortElements(organizationActiveUsers).map((coach) => {
          const { _id, name } = coach;
          return (
            <li
              key={_id}
              onClick={(e) => {
                setIsUnfolded(!isUnfolded);
                onSelectCoach(e, coach);
              }}
            >
              <img src={getAvatarUrl(coach)} alt={t("manageCoaches.avatarAlt")} />
              <span>{name}</span>
            </li>
          );
        })}
      </ul>
    </details>
  );
};

export default ChooseCoach;
